import React, { FC, useState, useEffect } from 'react';
import { Box, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TabInterface } from '../../interfaces/simpleTabs.interface';
import { Colors } from '../../constants/constants';
import LinkTab from './linkTab';

interface SimpleTabProps {
    tabs: TabInterface[],
    currentTab?: number
}

const SimpleTabs: FC<SimpleTabProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const activeTabFromRoute = props.currentTab !== undefined
    ? props.currentTab
    : props.tabs.findIndex((tab) => location.pathname.includes(tab.href));

  const [activePanel, setActivePanel] = useState<number>(activeTabFromRoute);

  useEffect(() => {
    setActivePanel(activeTabFromRoute);
  }, [location.pathname, activeTabFromRoute]);

  const onPanelChange = (_e: React.SyntheticEvent, value: number) => {
    setActivePanel(value);
    navigate(props.tabs[value].href);
  };

  return (
    <>
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        height: 39,
        width: 'calc(100% + 48px)',
        marginLeft: '-1.5rem',
        paddingLeft: '1.5rem',
      }}
      >
        <Tabs
          value={activePanel}
          onChange={onPanelChange}
          aria-label="basic tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: Colors.primary,
              height: 3,
              borderTopLeftRadius: 25,
              borderTopRightRadius: 25,
              bottom: 9,
            },
          }}
        >
          {props.tabs.map((tab, index) => (
            <LinkTab
              key={index}
              label={t(tab.tabLabel) || tab.tabLabel}
              id={`tab.identifierName-${index}`}
              href={tab.href}
              icon={tab?.icon
                ? <img src={tab?.icon} alt="tab-icon" className="h-[16px] object-contain" /> : undefined}
            />
          ))}
        </Tabs>
      </Box>
      <Box className="size-full py-6">
        <Outlet />
      </Box>
    </>
  );
};

export default SimpleTabs;
